import { Button, Grid, InputAdornment, Theme, useMediaQuery, FormHelperText } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { FormDropdown } from 'src/components/FormPart/FormDropdown';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { SelectOption } from 'src/UIKit';
import { ContactInfoFormData } from '../../types';
import moment from 'moment';
import { FormContactDatePicker } from 'src/components/FormPart/FormContactDatePicker';
import { FormNumberInput } from 'src/components/FormPart/FormNumberInput';

type EditContactInfoFormProps = object;

export const EditContactInfoForm: FC<
  FormComponentProps<ContactInfoFormData, EditContactInfoFormProps>
> = props => {
  const { form } = props;
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  
  const timezones: SelectOption<string, string, string>[] = useMemo(() => {
    return (
      moment.tz.zonesForCountry('US').map(a => ({
        value: a,
        title: a,
        entity: a,
      })) || []
    );
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={isMobile ? 12 : 6}>
        <FormTextInput
          form={form}
          fieldName="firstName"
          label="First Name"
          placeholder="Enter First Name"
        />
      </Grid>
      <Grid item xs={isMobile ? 12 : 6}>
        <FormTextInput
          form={form}
          fieldName="lastName"
          label="Last Name"
          placeholder="Enter Last Name"
        />
      </Grid>
      <Grid item xs={isMobile ? 12 : 6}>
        <FormNumberInput
          form={form}
          fieldName="phoneNumber"
          label="Phone Number"
          placeholder="Enter Phone Number"
          format={{style: "phoneNumber"}}
          max={9999999999}
          validation={{
              required: "Phone Number is required",
            }}
          inputProps={{
              startAdornment: <InputAdornment position="start">+1</InputAdornment>,
            }}
        />
      </Grid>
      <Grid item xs={isMobile ? 12 : 6}>
        <FormContactDatePicker
          form={form}
          fieldName="birthdate"
          label="Birthdate"
          placeholder="Enter Birth date"
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextInput form={form} fieldName="email" label="Email" placeholder="Emal" />
      </Grid>
      <Grid item xs={12}>
        <FormDropdown
          form={form}
          fieldName="timeZone"
          label="Timezone"
          placeholder="Enter Timezone"
          options={timezones}
        />
      </Grid>
      {form.formState.errors?.root?.message && (
        <Grid item xs={12}>
          <FormHelperText error>
            {form.formState.errors?.root?.message}
          </FormHelperText>
        </Grid>
      )}

      <Grid item xs={12}>
        <Grid container direction={'row-reverse'}>
          <Button
            type="submit"
            disabled={form.formState.isSubmitting || !form.formState.isDirty || !form.formState.isValid}
            variant="contained"
            color="secondary"
            size="large"
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
